import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import AnimatedComponent from "../../Components/AnimatedComponent";
import { fadeInY } from "../../utils/animatedVariants";
import { Link } from "react-router-dom";

import footerimage from '../../assets/images/layout/P38TAAB-min-min.png'
import logo from "../../assets/images/logo/BCT_logo_light.png"

// Icons
import { IoIosArrowForward } from "react-icons/io";
import { GrFacebookOption } from "react-icons/gr";
import { IoLogoTwitter } from "react-icons/io5";
import { BsInstagram } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { toast, } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Images
import Gflage from "../../assets/images/flage/Flag_of_Guinea.png"
import Eflage from "../../assets/images/flage/us-flag.png"
import axios from 'axios';
import { useNetworkError } from '../../hooks/context/NetworkErrorContext';
import { getEnvVar } from "../../config/env-config";

export default function Footer() {
  const { t } = useTranslation();
  const [isActive, setIsActive] = useState(false);
  const [selectedOption, setSelectedOption] = useState('English'); // Default selected option
  const [logocountry, setlogocountry] = useState(Gflage); // Default selected option
  const [wlCompanyName, setWlCompanyName] = useState([]);
  const { setInternetError } = useNetworkError(); // Using the context

  // To get WL details
  const getWlDetails = () => {
    axios.post((getEnvVar('REACT_APP_USER_PUBLIC_URL') || '') + "api/public/" + "wl_logo_details",
      {},
      {
        "Content-Type": "multipart/form-data",
        headers: {
          // "api-token": "68481d08a799ad6967f57263",
        },
      }).then((response) => {
        if (response.data) {
          if (response.data.code === 200) {
            setWlCompanyName(response.data.data.company_name);
          } else if (response.data.code === 500) {
            toast.error(response.data.message);
          } else if (response.data.code === 404) {
            toast.error(response.data.message);
          } else {
            toast.error(response.data.message, { autoClose: 5000 });
          }
        }
      }).catch((error) => {
        console.error("API Error:", error);

        if (!error.response) {
          // Network/connection/server error
          setInternetError(true);
        } else {
          setInternetError(false);
        }

        toast.error("Failed to load booking details.");
      });
  };

  // To get WL details
  useEffect(() => {
    getWlDetails();
  }, []);

  useEffect(() => {
    if (selectedOption === "Français") {
      setlogocountry(Gflage)
    } else {
      setlogocountry(Eflage)
    }
  }, [selectedOption])

  const handleOptionClick = (language, countryFlag) => {
    setSelectedOption(language); // Update the selected option
    setlogocountry(countryFlag); // Change the flag image
    i18next.changeLanguage(language === 'Français' ? 'guinea' : 'english'); // Change the i18next language
    setIsActive(false); // Close the dropdown
  };

  return (
    <footer className={'h-full w-full py-16  3xl:px-32 2xl:px-32 lg:px-16 px-6 bg-cover relative'} style={{ backgroundImage: `url(${footerimage})` }}>
      <div className={'absolute bg-[#051b34e0] inset-0 bg-violet-500/90 z-3'}></div>
      <AnimatedComponent
        tag="nav"
        variants={fadeInY(0.5)}
        className={''}
        aria-label={'Footer Navigation'}>


        <div className={''}>

          <div className={'mx-auto  relative z-10 pt-10 pb-20 lg-max:pb-5'}>
            <div className={'p-6 bg-[#1c55ab] flex lg-max:inline-block justify-between items-center gap-8 rounded-[8px]'}>

              <span className={'text-left flex gap-5 items-center'}>
                <img className={'w-36 lg-max:w-20 sm-max:hidden'} src={logo} alt='logo' />
                <h6 className={'text-white text-[20px] lg-max:text-[16px] font-semibold lg-max:text-center'}>
                  {t("main.Footer.ready_pay")}
                </h6>
                {/* <p className="text-[#ffffff99] text-[14x] font-normal">sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis.</p> */}
              </span>
              {/* Button Area */}
              <div className={'lg-max:flex lg-max:!justify-center lg-max:mt-3'}>
                <div className={'b  relative h-14 w-64 lg-max:w-56 lg-max:h-12 flex justify-center items-center'}>
                  <div className={'i h-14 w-64 lg-max:w-56 lg-max:h-12 bg-gradient-to-br from-[#fe7b05] to-[#eabb76] items-center rounded-sm shadow-2xl cursor-pointer absolute overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out'}>
                  </div>
                  <Link className={'text-center text-white font-medium lg-max:text-sm flex items-center z-10 pointer-events-none'}>
                    {t("main.Footer.Get_started_now")}  <IoIosArrowForward className={'ml-2'} /></Link>

                </div>
              </div>

            </div>
          </div>
          <div className={'mx-auto  relative z-10'}>


            <div className={'mt-8 grid grid-cols-2 gap-8 lg:mt-0 lg:grid-cols-6 xl:grid-cols-6 2xl:grid-cols-6 lg:gap-y-16 relative px-30 z-5 text-left'}>

              <div className={'col-span-2'}>
                <p className={'font-medium text-white uppercase'}>{t("main.Footer.Footer_menu.about")} </p>

                <span className={'mt-6 leading-8	 inline-block text-[14px] text-[#ffffff99]'}>{t("main.Footer.Footer_menu.about_detail")}</span>
              </div>

              {/* <div className="col-span-2 sm:col-span-1">
                  <p className="font-medium text-white">SOLUTIONS</p>

                  <ul className="mt-6 space-y-4 text-sm menu-item ">
                    <li className=" transition hover:opacity-75">
                      <Link href="#" >eCommerce</Link>
                      </li>
                      <li className=" transition hover:opacity-75">
                      <Link href="#" >Fintech</Link>
                      </li>
                      <li className=" transition hover:opacity-75">
                      <Link href="#" >Gaming</Link>
                        </li>
                        <li className=" transition hover:opacity-75">
                      <Link href="#" >Marketplace</Link>
                        </li>
                        <li className=" transition hover:opacity-75">
                      <Link href="#" >Payment facilitators</Link>
                        </li>
                  
                  </ul>
                </div> */}

              <div className={'col-span-2 sm:col-span-1'}>
                <p className={'font-medium text-white uppercase'}>{t("main.Footer.Footer_menu.Company")}</p>

                <ul className={'mt-6 space-y-4 text-sm menu-item'}>
                  <li className={'transition hover:opacity-75'}>
                    <Link to={"/"} >{t("main.Footer.Footer_menu.Our_Mission")}</Link>
                  </li>
                  <li className={'transition hover:opacity-75'}>
                    <Link to={"/"} >{t("main.Footer.Footer_menu.Our_Customers")}</Link>
                  </li>
                  <li className={'transition hover:opacity-75'}>
                    <Link to={"/"} >{t("main.Footer.Footer_menu.Leadership_Team")}</Link>
                  </li>
                  {/* <li className=" transition hover:opacity-75">
                      <Link href="#" >Newsroom</Link>
                        </li> */}


                </ul>
              </div>

              <div className={'col-span-2 sm:col-span-1 menu-item'}>
                <p className={'font-medium text-white uppercase'}>{t("main.Footer.Footer_menu.DEVELOPERS")}</p>

                <ul className={'mt-6 space-y-4 text-sm menu-item'}>
                  <li className={'transition hover:opacity-75'}>
                    <Link to={"/"} >{t("main.Footer.Footer_menu.Documentation")}</Link>
                  </li>
                  <li className={'transition hover:opacity-75'}>
                    <Link to={"/"} >{t("main.Footer.Footer_menu.API_Reference")}</Link>
                  </li>
                  <li className={'transition hover:opacity-75'}>
                    <a
                      href="/developer-portal"
                    // target="_blank"
                    // rel="noopener noreferrer"
                    >
                      {t("main.Footer.Footer_menu.Developer Portal")}
                    </a>
                  </li>


                </ul>
              </div>

              <div className={'col-span-2 sm:col-span-1 menu-item '}>
                <p className={'font-medium text-white uppercase'}>{t("main.Footer.Footer_menu.RESOURCES")}</p>

                <ul className={'mt-6 space-y-4 text-sm'}>
                  <li className={'transition hover:opacity-75'}>
                    <Link to={"/"}> {t("main.Footer.Footer_menu.Blog")} </Link>
                  </li>

                  <li className={'transition hover:opacity-75'}>
                    <Link to={"/"} >  {t("main.Footer.Footer_menu.Terms_Conditions")} </Link>
                  </li>
                  <li className={'transition hover:opacity-75'}>
                    <Link to={"/"} > {t("main.Footer.Footer_menu.Privacy_Policy")} </Link>
                  </li>
                  {/* <li className=" transition hover:opacity-75">
                    <Link href="#" > Contact Us </Link>
                    </li> */}
                </ul>
              </div>

              <div className={'col-span-2 sm:col-span-1 menu-item'}>
                <p className={'font-medium text-white uppercase'}>{t("main.Footer.Footer_menu.CONTACTUS")}</p>


                <ul className={'mt-6 space-y-4 text-sm'}>
                  <li>
                    {t("main.Footer.Footer_menu.address")}
                  </li>

                  <li>
                    <Link to={"/"} > {t("main.Footer.Footer_menu.phonenumber")}</Link>
                  </li>
                  <li>
                    <Link to={"mailto:info@bctpay.app"} >{t("main.Footer.Footer_menu.mailid")}</Link>
                  </li>
                  <li>
                    <ul className={'flex flex-wrap justify-start gap-4 text-xs items-center'}>
                      <li className="dj">
                        <Link to={"https://www.facebook.com/BCTPay/"} className={'text-[#ffffff99] transition hover:opacity-75'}>
                          <GrFacebookOption /></Link>
                      </li>

                      <li>
                        <Link to={"https://www.twitter.com/BCTPay"} className={'text-[#ffffff99] transition hover:opacity-75'}>
                          <IoLogoTwitter /></Link>
                      </li>

                      <li>
                        <Link to={"#"} className={'text-[#ffffff99] transition hover:opacity-75'}
                        ><BsInstagram /></Link>
                      </li>

                      <li>
                        <Link to={"https://www.linkedin.com/company/BCTPay"} className={'text-white transition hover:opacity-75'}>
                          <FaLinkedinIn /></Link>
                      </li>


                    </ul>
                  </li>
                </ul>
              </div>



            </div>
          </div>



          <div className={'mx-auto  relative z-10 pt-10 mt-4'}>
            <div className={'flex justify-between items-center'}>
              <p className={'text-xs text-[#ffffff99]'}>©{1900 + new Date().getYear()} {wlCompanyName} {t('main.EventBooking.footerText')} </p>
            </div>
          </div>

        </div>
      </AnimatedComponent>
    </footer>
  );
}
